import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src='./images/404error.jpg' alt="Logo" height='900' width='auto' className="img-fluid"/>
            
            
        </div>
    );
};

export default NotFound;